import * as React from "react"
import { ViewType } from "@digits-graphql/frontend/graphql-bearer"
import envHelper from "@digits-shared/helpers/envHelper"
import { LayoutContext } from "src/frontend/components/Shared/Layout/LayoutProvider"
import { type PortalAction } from "src/frontend/components/Shared/Portals/State/actions"
import { initialBuilderState } from "src/frontend/components/Shared/Portals/State/reducer"
import { type PortalState } from "src/frontend/components/Shared/Portals/State/types"

/**
 * @deprecated This hook is kept for backward compatibility only.
 * The original Zustand implementation was a singleton that leaked memory
 * because it maintained state even after components were unmounted.
 *
 * Please migrate to useLayoutContext instead.
 *
 */
export function usePortalStore<T>(selector: (state: PortalState) => T): T {
  const context = React.useContext(LayoutContext)
  if (!context) {
    if (envHelper.isProduction()) {
      console.error("usePortalStore must be used within a LayoutProvider")
      return selector(
        initialBuilderState({
          legalEntityId: "",
          viewType: ViewType.Unknown,
          viewVersion: "",
        })
      )
    }
    throw new Error("usePortalStore must be used within a LayoutProvider")
  }

  return selector(context.state as PortalState)
}

/**
 * @deprecated This hook is kept for backward compatibility only.
 * The original Zustand implementation was a singleton that leaked memory
 * because it maintained state even after components were unmounted.
 *
 * Please migrate to useLayoutContext instead.
 *
 */
export function usePortalDispatch() {
  const context = React.useContext(LayoutContext)
  if (!context) {
    if (envHelper.isProduction()) {
      console.error("usePortalDispatch must be used within a LayoutProvider")
      return () => ({})
    }
    throw new Error("usePortalDispatch must be used within a LayoutProvider")
  }
  return context.dispatch as React.Dispatch<PortalAction>
}
